import { ApiService } from 'src/app/services/api.service';
import { Injectable } from '@angular/core';
import { APIs } from '../config/api.constant';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ParkUploadService } from './park-upload.service';

@Injectable({
  providedIn: 'root',
})
export class ParkService {
  detail: any;
  constructor(
    private apiService: ApiService,
    private parkUploadService: ParkUploadService,
  ) {}

  uploadImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      console.log('came here 1', event.target);
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0].size);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          console.log('event', event);
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  getCity(id){
    return this.apiService.get(APIs.getSIngleCity,id).pipe(map(response => {
          return response.list;
        }));
  }

  insertCity(data, isNewPark) {
    return this.apiService.post(APIs.saveParkDetails + `?isNewPark=${isNewPark}`, data).pipe(
      map((response) => response)
    );
  }

  /**
   * Save park/property with multipart form data (images as photoData + fileName).
   * Uses ParkUploadService so Content-Type is not set and browser sends multipart/form-data with boundary.
   */
  insertParkFormData(formData: FormData, isNewPark: boolean) {
    return this.parkUploadService.postFormData(APIs.saveParkDetails + `?isNewPark=${isNewPark}`, formData).pipe(
      map((res) => res)
    );
  }

  getAmentities() {
    return this.apiService.get(APIs.getAmentities).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

  getPropertyType() {
    return this.apiService.get(APIs.getParkType).pipe(
      map((response) => {
        return response.list;
      })
    );
  }

  getCityContent() {
    return this.apiService.get(APIs.getCity).pipe(
      map((res) => {
        return res.list;
      })
    );
  }

  // park building

  saveBuilding(data) {
    return this.apiService.post(APIs.saveParkBuilding, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getBuildings(id,data) {
    return this.apiService.get(APIs.getParkBuilding+`?parkId=${id}&parkTenantId=${data}`).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  deleteBuilding(data){
    return this.apiService.get(APIs.deleteBuilding, data).pipe(map(response => {
      return response;
    }))
  }

  saveCity(data){
    return this.apiService.post(APIs.saveCity, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  /**
   * Save city with multipart form data (image file + cityId, cityName, isActive).
   * Uses ParkUploadService so Content-Type is not set and browser sends multipart/form-data with boundary.
   */
  saveCityFormData(formData: FormData) {
    return this.parkUploadService.postFormData(APIs.saveCity, formData).pipe(
      map((res) => res)
    );
  }

removeParkImage(data){
  return this.apiService.post(APIs.removeParkImage+`?fileName=${data.filename}&id=${data.id}`).pipe(map((res) => {
    return res;
  }))
}

}
